import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(list: any[], fn: Function): any {
    if (!list || !fn) {
      return list;
    }
    return list.filter((value, idx, list) => fn(value, idx, list));
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/pipes/filter.pipe.ts